import { SyntheticEvent, useEffect, useState } from 'react'
import { getVideoMap } from '../api/live/live'
import { CustomizeLive } from '../components'
import { LiveGrid } from '../components/live/LiveGrid'
import { LivePlayer } from '../components/live/LivePlayer'
import { useTankInfoModalStore } from '../store/tankInfo/useTankInfoModalStore'
import { videoMapResponseType } from '../types/apiResponse/liveTypes'

export default function Live() {
  const [videoMap, setVideoMap] = useState<videoMapResponseType | null>(null)
  const { open, setTank, setVideo, isOpen } = useTankInfoModalStore()
  const videoUpdate = () => {
    getVideoMap(setVideoMap)
  }
  useEffect(() => {
    getVideoMap(setVideoMap)
  }, [])

  return (
    <div className="p-4 md:p-[40px]">
      <div className="relative flex flex-col md:flex-row justify-between gap-4 mb-6 md:mb-[40px]">
        <p className="font-bold text-2xl md:text-[2rem]">Live</p>
        <div className="absolute -top-1 right-0 md:relative md:top-auto md:right-auto flex items-center">
          <CustomizeLive setIsUpdated={videoUpdate} videoMap={videoMap} />
        </div>
      </div>
      {videoMap !== null ? (
        <LiveGrid {...videoMap}>
          {videoMap.videoUrls.map((videoProps, index) => {
            const onVideoClick = (e: SyntheticEvent) => {
              setTank(videoProps.tankId, videoProps.tankName)
              setVideo(videoProps.hlsUri, videoProps.cameraPosition)
              e.preventDefault()
              e.stopPropagation()
              open()
            }
            return (
              <LivePlayer
                key={index}
                isPlaying={!isOpen}
                latestGridKey={videoMap.latestGridKey}
                tankName={videoProps.tankName}
                hlsUri={videoProps.hlsUri}
                cameraPosition={videoProps.cameraPosition}
                onClick={videoProps.hlsUri ? onVideoClick : () => {}}
                isOnHover={true}
              />
            )
          })}
        </LiveGrid>
      ) : (
        <></>
      )}
    </div>
  )
}
